<!-- ngif to remove element from the dom if not logged in -->
<app-chatbot *ngIf="isUserLoggedIn && dailyJobRundown"></app-chatbot> 
<app-toast></app-toast>
<router-outlet></router-outlet>